import { AppStartListening } from '@/reducers/listeners';
import type { UpdateUserResponse } from '@/types';
import { isAnyOf } from '@reduxjs/toolkit';
import { checkPendingUsers, updateUser } from './actions';

export const userManageListeners = (startListening: AppStartListening) => {
  startListening({
    matcher: isAnyOf(updateUser.fulfilled),
    effect: async (action, listenerApi) => {
      const payload = action.payload as UpdateUserResponse;

      if (payload.status !== undefined) {
        await listenerApi.dispatch(checkPendingUsers());
      }
    },
  });
};
